import React from 'react';
import PropTypes from 'prop-types';
import { primary, gold, blueGrey, successGreen } from '../assets/colors';
import Badge from './Badge';
var typeLabel = {
  MB: 'PGA MEMBER',
  ST: 'STUDENT',
  AP: 'ASSOCIATE',
  PE: 'PUBLIC EMPLOYER',
  PQ: 'PRE-QUALIFIER',
  QE: 'QUALIFIER ELIGIBLE',
  TA: 'TERMINATED APPRENTICE',
  FA: 'FACILITY',
  AF: 'AFFILIATE'
};
var typeBadgeColor = {
  MB: '' + gold,
  ST: '' + primary,
  AP: '' + blueGrey,
  FA: '' + successGreen
};
var isAffiliate = function isAffiliate(memberClass) {
  return memberClass === 'AF';
};
var MemberTypeBadge = function MemberTypeBadge(_ref) {
  var type = _ref.type,
    memberClass = _ref.memberClass;
  return React.createElement(Badge, {
    color: typeBadgeColor[type]
  }, isAffiliate(memberClass) ? typeLabel.AF : typeLabel[type]);
};
MemberTypeBadge.displayName = 'MemberTypeBadge';
MemberTypeBadge.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.oneOf(['MB', 'ST', 'AP', 'PE', 'QE', 'PQ', 'TA', 'FA']).isRequired,
  class: PropTypes.string
} : {};
export default MemberTypeBadge;